import { KioskAuthenticationMode as KioskAuthMode } from 'types/company/kiosk/IKioskSettings';
import { TimeRegistrationRoundingDirection } from 'types/company/time-registration/ITimeRegistrationSettings';

export enum PolicyUnit {
  AllowRegistrationBeforePlannedStart = 1,
  AllowStartInFuture = 2,
  RegistrationWindow = 3,
  ExtendedRegistrationWindow = 4,
  MaximumNumberOfBreaks = 5,
  BreakRounding = 6,
  StartEndRounding = 7,
  OverworkLimit = 8,
  AutoFreezeOnClockOut = 9,
  KioskAuthenticationMode = 10,
  PersonalDeviceBlock = 11,
  KioskModeAvailability = 12,
  LocationCapture = 13,
}

export interface UnitValue {
  enabled?: boolean | null;
  beforeMinutes?: number | null;
  afterMinutes?: number | null;
  maximum?: number | null;
  startIntervalMinutes?: number | null;
  startDirection?: TimeRegistrationRoundingDirection | null;
  endIntervalMinutes?: number | null;
  endDirection?: TimeRegistrationRoundingDirection | null;
  maxOverworkMinutes?: number | null;
  authenticationMode?: KioskAuthMode | null;
  onSiteRadiusMeters?: number | null;
}

export type UnitValueField = keyof UnitValue;

export interface ProposedUnitState {
  value: UnitValue;
  overrulable: boolean;
}

export interface UnitState extends ProposedUnitState {
  unit: PolicyUnit;
}

export interface TimeRegistrationPolicyView {
  units: UnitState[];
}

export interface ImpactDto {
  companiesReceivingChange: number;
  companiesLosingOverrule: number;
  isLock: boolean;
  isUnlock: boolean;
}

export interface PolicyErrorDetails {
  field?: UnitValueField;
  min?: number;
  max?: number;
  unit?: string;
}

export interface FieldError {
  key: string;
  params?: Record<string, number>;
}

export type FieldErrors = Partial<Record<UnitValueField, FieldError>>;

export type PolicySaveResult =
  | { status: 'success'; state: UnitState }
  | { status: 'conflict' }
  | { status: 'timeout' }
  | { status: 'invalid'; fieldErrors: FieldErrors }
  | { status: 'error' };

export type PolicyImpactResult = { status: 'ok'; impact: ImpactDto } | Exclude<PolicySaveResult, { status: 'success' }>;

export interface ITimeRegistrationPolicyState {
  units: UnitState[];
  loading: boolean;
  loadError: boolean;
}
